import { Pipe, PipeTransform } from '@angular/core';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';

@Pipe({
    name: 'onlyPriceRequest'
})
export class ProductFilterPipe implements PipeTransform {
    /**
   * Sadece fiyat talep edilmesi gereken ürünleri filtreler. ürün listesi alır ürün listesi döner.
   * @param products - Filtrelenecek ürün dizisi.
   * @returns Filtrelenmiş ürün dizisi.
   */
  transform(products: MarketSeaProductsModel[] | null | undefined): MarketSeaProductsModel[] {
    // Liste null, undefined veya boşsa olduğu gibi döndür
    if (!products || products.length === 0) {
      return [];
    }
    return products.filter(product => {
        
        const shouldBeShown =  ((product?.isOverLimit && !product?.isSelectedFromList) || product?.freights?.errorCode) 
            || product?.hasNoOnlinePrice 
            || (!product?.hasNoOnlinePrice && !product.freights);

    
        return shouldBeShown;
        });
  }
}